// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type AccountId = ID<"account">;
export const accountIdFormat = idFormat<AccountId>({ prefix: "acc_" });

export type MerchantPersonId = ID<"merchantPerson">;
export const merchantPersonIdFormat = idFormat<MerchantPersonId>({
  prefix: "mpn_",
});

export type MerchantPersonPhoneId = ID<"merchantPersonPhone">;
export const merchantPersonPhoneIdFormat = idFormat<MerchantPersonPhoneId>({
  prefix: "mpp_",
});

export type MerchantPersonPhoneChallengeId = ID<"merchantPersonPhoneChallenge">;
export const merchantPersonPhoneChallengeIdFormat =
  idFormat<MerchantPersonPhoneChallengeId>({ prefix: "mpc_" });
